import React, { useState, useEffect } from 'react'
import {
  Box,
  Text,
  Button,
  CheckBox,
  ThemeContextExtend,
  Captcha,
} from '@usap/uicomponents'
import validate from '../../helpers/validation'
import FormTheme from './config/form-theme'
import InputText from './InputText'
import { notifySchema } from './ValidationSchema'
import UserInfoMsg from './UserInfoMsg'

export default function ({
  oosProducts,
  onClickNotify,
  id,
  closePopUp,
  enableButton,
  siteKey,
}) {
  const [successful, setSuccessful] = useState(false)

  const [errors, setError] = useState({})
  const [formData, setFormData] = useState({})

  const [checked, setChecked] = useState(false)

  const [captcha, setCaptcha] = useState(false)

  useEffect(() => {
    if (captcha) {
      setError({ ...errors, captcha: false })
      setFormData({ ...formData, captcha })
    }
  }, [captcha])

  return (
    <ThemeContextExtend value={FormTheme}>
      <Box pad="24px">
        {!successful && (
          <Box>
            <Box width="450px">
              <Text size="small" color="dark-2" margin={{ bottom: 'medium' }}>
                Enter your email address below to be notified when items are back in stock
              </Text>
            </Box>
            <Box>
              <InputText
                label={(
                  <Text size="small" color="dark-2" weight="bold">
                    Email Address
                  </Text>
                )}
                id="emailAddress"
                name="emailAddress"
                type="email"
                placeholder="Enter email address"
                onChange={event => {
                  const { name, value } = event.target
                  setError({
                    [name]: '',
                  })
                  setFormData({ ...formData, [name]: value })
                }}
                value={formData.emailAddress}
                error={errors.emailAddress}
                aria-label="email"
              />
              <Box pad={{ top: 'medium', bottom: 'small' }}>
                <CheckBox
                  checked={checked}
                  label={(
                    <Text size="small" color="dark-2">
                      Send me CarParts exclusive offers and promotions.
                    </Text>
                  )}
                  onChange={event => setChecked(event.target.checked)}
                />
              </Box>
              <Box pad={{ vertical: 'medium' }} alignSelf="start">
                <Captcha
                  id="notifyme"
                  name="notifyme"
                  setCaptcha={setCaptcha}
                  error={errors.captcha}
                  siteKey={siteKey}
                  reset={Boolean(successful)}
                />
              </Box>
            </Box>
          </Box>
        )}
        <Box pad="small">
          {!successful ? (
            <Button
              id="notifyMe"
              primary
              custom
              hideBorder
              label="Notify Me"
              onClick={() => {
                const hasError = validate(formData, notifySchema(formData))
                if (hasError) {
                  return setError(hasError)
                }

                return onClickNotify(
                  formData.emailAddress,
                  id || oosProducts,
                  formData.captcha,
                ).then(({ data } = {}) => {
                  if (
                    data &&
                    data.data &&
                    data.data.success
                  ) { setSuccessful(true) }
                })
              }}
            />
          ) : (
            <Box width="100%" align="center">
              <UserInfoMsg
                bgColor="green"
                icon="check"
                infoType="Thank you. You will receive an email when the item becomes available."
              />
              <Box pad="small">
                <Button
                  primary
                  hideBorder={false}
                  label="Continue shopping"
                  onClick={() => {
                    closePopUp(false)
                    if (enableButton) enableButton(false)
                  }}
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </ThemeContextExtend>
  )
}
